export enum Mimes {
  ApplicationJson = 'application/json',
  ApplicationOctetStream = 'application/octet-stream',
  ApplicationXml = 'application/xml',
  ApplicationJsonPatch = 'application/json-patch+json',
  ApplicationXWwwFormUrlencoded = 'application/x-www-form-urlencoded',
  TextPlain = 'text/plain',
  TextHtml = 'text/html',
  All = '*/*',
  TextCss = 'text/css',
  TextJavascript = 'text/javascript',
  TextXml = 'text/xml',
  TextXslt = 'text/xslt',
  TextXmlDtd = 'text/xml-dtd',
  TextPlainUtf8 = 'text/plain; charset=utf-8',
  ImagePng = 'image/png',
  ImageGif = 'image/gif',
  ImageJpeg = 'image/jpeg',
  ImageSvg = 'image/svg+xml',
  ImageBmp = 'image/bmp',
  ImageTiff = 'image/tiff',
  ImagePdf = 'application/pdf',
  ImageXBmp = 'image/x-bmp',
  ImageXpixmap = 'image/x-xpixmap',
  ImageXxbm = 'image/x-xbm',
  MultipartFormData = 'multipart/form-data',
  ApplicationJsonPostSimpleBootSsrIntentScheme = 'application/json-post+simple-boot-ssr-intent-scheme',
  Intent = 'intent'
}
